import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../Core/Container';

export const StyledContainer = styled(Container)`
  margin-top: 30px;
  margin-bottom: 30px;

  @media only screen and (max-width: calc(${themeGet(
      'breakpoints.md',
    )} - 1px)) {
    width: 100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 50px;
    margin-bottom: 50px;
  }
`;

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.white')};
  padding: 30px 15px;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    padding: 30px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 40px;
  }
`;

export const TableTitle = styled.div`
  display: flex;
  border-bottom: 2px solid ${themeGet('colors.light-border-grey')};
  padding-bottom: 30px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding-bottom: 40px;
  }
`;

export const TableRow = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid ${themeGet('colors.light-border-grey')};
  padding: 30px 0;
  margin: -0.5rem;

  &:last-child {
    border: none;
    padding-bottom: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 40px 0;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

export const TableCell = styled.div`
  padding: 0.5rem;
  width: 100%;
  flex: none;

  p {
    margin: 0 !important;
    word-break: break-word;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 33.333%;

    &:last-child {
      width: auto;
    }

    & + &:last-child {
      width: 33.333%;
    }
  }
`;
